import {DocumentationCategory} from './documentation-constant.enum';
import {DocumentStamp} from '../../export/shared';
import {OrderInformation} from '../../project/shared/project-model';
import {documentationCategory} from "../model/documentation-category.model";

export class Documentation {

  id: string;

  title: string;
  titleTranslated?: string;
  category: DocumentationCategory;
  language: string;

  fileName: string;
  link?: string;
  size: string;
  extension: string;
  range: string;
  references: string[];
  downloadInProgress: boolean;

  bslDocumentation: boolean;

  stamperInformation: DocumentStamp;
  orderInformation?: OrderInformation;


  lastUpdateDate: number;
  localFileId: string;

  transferToCpq: boolean;
  cpqPriority: number;
}

export class TechnicalDocumentation extends Documentation {
  itemId: string;

  constructor(base: Documentation, itemId: string) {
    super();
    Object.assign(this, base);
    this.itemId = itemId;
  }
}

export class EditDocumentationForm {
  id?: string;
  name?: {
    [key: string]: string;
  };
  fileName?: string;
  category?: string;
  localFileId?: string;
  extension?: string;
  references?: string[];
  transferToCpq?: boolean;
  priority?: number;
}
